module.exports = __webpack_public_path__ + "static/media/mongodb.98a494af.png";